/* eslint-disable @typescript-eslint/no-explicit-any */
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import singleFromArrayTransform from '@/core/config/dataMapping/SingleFromArrayTransform';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { getFormMapping } from '@/core/config/viewMapping/GeneralFormMapping';
import Messages from '@/core/helpers/Messages';
import { Utils } from '@/core/helpers/Utils';
import { hideModalByClass } from "@/core/helpers/dom";
@Module
export default class DynamicFormModule extends VuexModule {
	dynamicEntity = {};
	relationships = {};
	isFromList = {};
	mapping = {} as any;
	values = {} as any;
	isMultipleUpdate = {};
	id = {};
	formWithImage = {};
	successFullySubmitted = {};
	formLoading = false;



	@Action({ rawError: true })
	async [Actions.SETUP_FORM](payload) {

		if (!payload.dontClearBeforeSetup) {
			this.context.commit(Mutations.CLEAR_FORM_MODULE)
		}
		const mapping = getFormMapping(payload.key);

		this.context.commit(Mutations.SET_SUCCESSFULLY_SUBMITTED, { key: payload.key, flag: false });
		this.context.commit(Mutations.SET_FORM_MAPPING, { key: payload.key, mapping: mapping });

		this.context.dispatch(Actions.SETUP_FORM_COMPONENT_OR_MODAL, payload);
	}
	@Action({ rawError: true })
	async [Actions.SET_IS_FROM_LIST](payload) {
		this.context.commit(Mutations.SET_IS_FROM_LIST, payload)

	}

	@Action({ rawError: true })
	async [Actions.SETUP_FORM_COMPONENT_OR_MODAL](payload) {

		if (this.mapping[payload.key].map) {
			if (this.mapping[payload.key].map.FormWithImage) {
				this.context.dispatch(Actions.SET_FORM_WITH_IMAGE_FLAG, { key: payload.key, flag: this.mapping[payload.key].map.FormWithImage });
			}
			else {

				this.context.dispatch(Actions.SET_FORM_WITH_IMAGE_FLAG, { key: payload.key, flag: false });
			}
				
			if (payload.id && payload.id != 0) {
				//set id for api call
				this.context.commit(Mutations.SET_ENTITY_ID, { key: payload.key, id: payload.id });
				//api call for data
				await this.context.dispatch(Actions.GET_DYNAMIC_ENTITY, { key: payload.key });

				//initialize form fields with the data of the api call
				this.context.dispatch(Actions.INITIALIZE_FORM_VALUES, { key: payload.key });

				//api call for all the relationships of entity
				await this.context.dispatch(Actions.INITIALIZE_FORM_RELATIONSHIP_LISTS, { key: payload.key });

			} else {
				if (payload.isMultipleUpdate) {
					this.context.commit(Mutations.SET_IS_MULTIPLE_UPDATE, { key: payload.key, isMultipleUpdate: true });
				}
				else {
					this.context.commit(Mutations.SET_IS_MULTIPLE_UPDATE, { key: payload.key, isMultipleUpdate: false });
				}
				this.context.commit(Mutations.SET_ENTITY_ID, { key: payload.key, id: 0 });
				//initialize form fields with empty values


				this.context.dispatch(Actions.INITIALIZE_FORM_VALUES, { key: payload.key });
				//api call for all the relationships of entity
				await this.context.dispatch(Actions.INITIALIZE_FORM_RELATIONSHIP_LISTS, { key: payload.key });

			}
		}

	}

	@Action({ rawError: true })
	[Actions.SET_ENTITY_ID](payload) {
		this.context.commit(Mutations.SET_ENTITY_ID, payload);
	}

	@Action({ rawError: true })
	[Actions.PUSH_PRODUCT_ATTRIBUTE](payload) {
		this.context.commit(Mutations.PUSH_PRODUCT_ATTRIBUTE, payload);
	}
	@Action({ rawError: true })
	[Actions.REMOVE_PRODUCT_ATTRIBUTE](payload) {
		this.context.commit(Mutations.REMOVE_PRODUCT_ATTRIBUTE, payload);
	}


	@Action({ rawError: true })
	[Actions.SET_SUCCESSFULLY_SUBMITTED](payload) {
		this.context.commit(Mutations.SET_SUCCESSFULLY_SUBMITTED, { key: payload.key, flag: payload.flag });
	}
	@Action({ rawError: true })
	[Actions.SET_FORM_WITH_IMAGE_FLAG](payload) {
		this.context.commit(Mutations.SET_FORM_WITH_IMAGE_FLAG, payload);
	}

	@Action({ rawError: true })
	async [Actions.GET_DYNAMIC_ENTITY](payload) {
		
		if (this.mapping[payload.key]) {
			const params = {};
			
			const response = await ApiService.get((this.mapping[payload.key].singleEndpoint ? this.mapping[payload.key].singleEndpoint : this.mapping[payload.key].endpoint ) + '/' + this.id[payload.key], '', params);
			
			const entity = response.data?.data ?? response.data;
			this.context.commit(Mutations.SET_DYNAMIC_ENTITY, { entity, key: payload.key });


			//called setup filters and relationships			
		}
	}

	@Action({ rawError: true })
	[Actions.CLEAR_ENTITY](payload) {
		this.context.commit(Mutations.SET_DYNAMIC_ENTITY, { key: payload.key, entity: {} });
	}

	@Action({ rawError: true })
	[Actions.INITIALIZE_FORM_RELATIONSHIP_LISTS](payload) {

		if (this.mapping[payload.key].map.Relationships) {
			this.mapping[payload.key].map.Relationships.forEach(async (relationship) => {
				const response = await ApiService.get(relationship.endpoint);
				const data = (relationship.dataMapping) ? relationship.dataMapping(response.data) : response.data;
			
				this.context.commit(Mutations.SET_DYNAMIC_ENTITY_RELATIONSHIPS, {
					key: payload.key,
					relationshipData: data,
					name: relationship.name,
				});
			});
		}
	}

	@Action({ rawError: true })
	[Actions.INITIALIZE_FORM_VALUES](payload) {

		this.context.commit(Mutations.CLEAR_VALUES, { key: payload.key });

		if (this.mapping[payload.key].map.InitFunctions) {
			this.mapping[payload.key].map.InitFunctions();

		}
		if (this.id[payload.key] == 0) {
			this.getFormMappingColumns({ key: payload.key }).forEach((column) => {
				
				if (column.value == 'multiple') {
					this.context.commit(Mutations.SET_VALUES, { key: payload.key, attrKey: column.nameForDb ? column.nameForDb : column.name, value: [] });
				}
				else {
					if (column.type == 'button') {

						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: column.defaultValue(),
						});
					}
					// else if (column.type === 'selectCustomFromJson') {
					// 	const jsonField = column.valueFrom?.jsonField ?? 'targetValue';

					// 	const raw = this.dynamicEntity[payload.key][jsonField];
					// 	if (raw) {
					// 		try {
					// 			const parsed = JSON.parse(raw);
					// 			const lookupKey = column.lookupKey(parsed);
					// 			const shortcut = column.shortCutMapToReceive[lookupKey];
					// 			if (shortcut) {
					// 				this.context.commit(Mutations.SET_VALUES, {
					// 					key: payload.key,
					// 					attrKey: 'marketTargetShortcut',
					// 					value: shortcut,
					// 				});
					// 			}
					// 		} catch (e) {
					// 			console.warn('Failed to parse targetValue JSON:', raw);
					// 		}
					// 	}
					// }
					else {
						
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: column.defaultValue ? column.defaultValue() : '',
						});
					}
				}
			});
		}
		else { //edit Mode


			this.getFormMappingColumns({ key: payload.key }).forEach((column) => {




				if (column.value == 'multiple') {
					
					if (column.transformToShow) {
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: (this.dynamicEntity[payload.key][column.name]) ? column.transformToShow(this.dynamicEntity[payload.key][column.name]) : [],
						});
					}
					else {
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: (this.dynamicEntity[payload.key][column.name]) ? this.dynamicEntity[payload.key][column.name] : [],
						});
					}
				}
				else if (column.value == 'singleFromArray') {
					if (column.transformToShow) {
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: (this.dynamicEntity[payload.key][column.name].length > 0) ? column.transformToShow(this.dynamicEntity[payload.key][column.name])[0] : null,
						});
					}
					else {
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: (this.dynamicEntity[payload.key][column.name].length > 0) ? this.dynamicEntity[payload.key][column.name][0] : null,
						});
					}
				}
				else if (column.type == 'object') {

					this.context.commit(Mutations.SET_VALUES, {
						key: payload.key,
						attrKey: column.nameForDb ? column.nameForDb : column.valueAttr,
						value: this.dynamicEntity[payload.key][column.name][column.valueAttr],
					});


				}
				else if (column.type === 'selectCustomFromJson') {

					const jsonField = column.valueFrom;

					const raw = this.dynamicEntity[payload.key][jsonField];
					if (raw) {

						try {
							const parsed = JSON.parse(raw);

							const lookupKey = column.lookupKey(parsed);
							const shortcut = column.shortCutMapToReceive[lookupKey];
							if (shortcut) {
								this.context.commit(Mutations.SET_VALUES, {
									key: payload.key,
									attrKey: column.valueAttr,
									value: shortcut,
								});
								this.context.commit(Mutations.SET_VALUES, {
									key: payload.key,
									attrKey: column.valueFrom,
									value: "",
								});
							}
						} catch (e) {
							console.warn('Failed to parse targetValue JSON:', raw);
						}
					}
				}
				else if (column.type === 'chipsNumberArray') {
					const raw = this.dynamicEntity[payload.key][column.name];
					let parsedArray = [];
					try {
						parsedArray = raw ? JSON.parse(raw) : [];
					} catch {
						parsedArray = [];
					}

					this.context.commit(Mutations.SET_VALUES, {
						key: payload.key,
						attrKey: column.name,
						value: parsedArray,
					});
				}
				else {
					if (column.type == 'button') {
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.name,
							value: column.initialValue(this.dynamicEntity[payload.key]),
						});
					}
					else {

						
						this.context.commit(Mutations.SET_VALUES, {
							key: payload.key,
							attrKey: column.nameForDb ? column.nameForDb : column.valueAttr,
							value: column.format ? column.format(this.dynamicEntity[payload.key][column.valueAttr]) : this.dynamicEntity[payload.key][column.valueAttr],
						});
					}
				}
			});
		}

	}

	@Action({ rawError: true })
	[Actions.TRANSFORM_DATA_FOR_REQUEST](payload) {

		let results = { ...payload.data };
		if(this.mapping[payload.key].map.TransformDataToSend){
			results = this.mapping[payload.key].map.TransformDataToSend(payload, this.mapping[payload.key].map.shortCuTMapToSent, results)
		}
		
		for (let index = 0; index < this.mapping[payload.key].map.Inputs.length; index++) {
			if (this.mapping[payload.key].map.Inputs[index].type == 'selectFromArray') {

				results[this.mapping[payload.key].map.Inputs[index].nameForDb] = singleFromArrayTransform(payload.data[this.mapping[payload.key].map.Inputs[index].nameForDb])
			}
			else if (this.mapping[payload.key].map.Inputs[index].type == 'decimal') {
				results[this.mapping[payload.key].map.Inputs[index].name] = parseFloat(payload.data[this.mapping[payload.key].map.Inputs[index].name])
			}
			else{				
				if (this.mapping[payload.key].map.Inputs[index].transformToSend) {
					results[this.mapping[payload.key].map.Inputs[index].name] = this.mapping[payload.key].map.Inputs[index].transformToSend(payload.data[this.mapping[payload.key].map.Inputs[index].name])
				}			
			}
		}
		return results;
	}

	@Action({ rawError: true })
	async [Actions.SET_FORM_LOADING](payload) {
		this.context.commit(Mutations.SET_FORM_LOADING, payload.flag)
	}
	@Action({ rawError: true })
	async [Actions.SAVE_ENTITY](payload) {

		this.context.commit(Mutations.SET_FORM_LOADING, true)
		let data = (await this.context.dispatch(Actions.TRANSFORM_DATA_FOR_REQUEST, payload));
		const updateMethod = (this.mapping[payload.key]?.map?.UpdateMethod || "patch").toLowerCase();
		const updateIdKey = this.mapping[payload.key]?.map?.UpdateIdKey;

		//let data = payload;
		let parentID = 0;
		if (this.mapping[payload.key].map.ParentID) {
			parentID = this.context.rootState.DynamicListModule.parentID[payload.key];
		}

		if (!this.formWithImage[payload.key]) {

			//if is update
			if (this.id[payload.key] != 0) {
				if (updateIdKey) {
					data = { ...data, [updateIdKey]: this.id[payload.key] };
				}
				else {
					data = { ...data, id: this.id[payload.key] };
				}
			}
			else {
				data = { ...data };
			}

			if (this.isMultipleUpdate[payload.key]) {
				const params = Utils.buildListParams(payload.key, 1)
				data = { ...data, ...params };
			}

			if (parentID != 0) {
				data[this.mapping[payload.key].map.ParentID] = parentID;
			}
			let tempId = 0;
			if (this.id[payload.key] != 0) {
				if (updateMethod === "post") {
					await ApiService.post(this.mapping[payload.key].updateEndpoint, data)
				}
				else {
					await ApiService.patch(this.mapping[payload.key].updateEndpoint, data)
				}
			}
			else {
				if (this.isMultipleUpdate[payload.key]) {

					await ApiService.patch(this.mapping[payload.key].multipleUpdate, data)
				}
				else {
					const response = await ApiService.post(this.mapping[payload.key].addEndpoint, data)
					if (response.status == 200) {
						tempId = response.data.data.id;
					}
				}
			}
			if (this.isFromList[payload.key]) {

				await this.context.dispatch(Actions.GET_DYNAMIC_LIST, { key: payload.key, page: 1 });
			}
			else {
				if (this.id[payload.key] == 0) {
					this.context.commit(Mutations.SET_ENTITY_ID, { key: payload.key, id: tempId });
				}
			}
		}
		else {

			if (this.id[payload.key] != 0) {
				payload.data.append("id", this.id[payload.key])
			}
			payload.data.append("brand", 'brand1')

			if (parentID[payload.key] != 0) {
				payload.data.append(this.mapping[payload.key].map.ParentID, parentID[payload.key])
			}
			let tempId = 0;

			if (this.id[payload.key] != 0) {
				await ApiService.patch(this.mapping[payload.key].updateEndpoint, payload.data, true);


			}
			else {
				const response = await ApiService.post(this.mapping[payload.key].addEndpoint, payload.data, true);
				if (response.status == 200) {
					tempId = response.data.data.id;
				}
				this.context.commit(Mutations.SET_ENTITY_ID, { key: payload.key, id: tempId });
			}
			if (this.isFromList[payload.key]) {
				this.context.dispatch(Actions.GET_DYNAMIC_LIST, { key: payload.key, page: 1 });
			}
			else {

				if (this.id[payload.key] == 0) {
					this.context.commit(Mutations.SET_ENTITY_ID, { key: payload.key, id: tempId });
				}
			}
		}

		this.context.commit(Mutations.SET_SUCCESSFULLY_SUBMITTED, { key: payload.key, flag: true });
		this.context.commit(Mutations.SET_FORM_LOADING, false)
		if (Object.keys(this.context.rootState.ErrorModule.errors).length == 0) {
			hideModalByClass(".dynamicEntityModal")
			Messages.showSuccess(this.mapping[payload.key].map.Single + " saved successfully");
		}
		if (this.mapping[payload.key].map.SaveCallBack) {
			this.context.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
			this.mapping[payload.key].map.SaveCallBack(this.id[payload.key]);
		}

	}

	@Mutation
	[Mutations.SET_DYNAMIC_ENTITY](payload) {

		this.dynamicEntity[payload.key] = { ...payload.entity };

	}
	@Mutation
	[Mutations.SET_FORM_LOADING](flag) {
		this.formLoading = flag;
	}
	@Mutation
	[Mutations.SET_IS_MULTIPLE_UPDATE](payload) {
		this.isMultipleUpdate[payload.key] = payload.isMultipleUpdate;
	}
	@Mutation
	[Mutations.SET_ENTITY_ID](payload) {
		this.id[payload.key] = payload.id;
	}
	@Mutation
	[Mutations.SET_FORM_MAPPING](payload) {
		this.mapping[payload.key] = { ...payload.mapping };
	}
	@Mutation
	[Mutations.SET_IS_FROM_LIST](payload) {

		this.isFromList[payload.key] = payload.flag;
	}

	@Mutation
	[Mutations.SET_VALUES](payload) {
		if (!this.values[payload.key]) {
			this.values[payload.key] = {};
		}


		this.values[payload.key][payload.attrKey] = payload.value;

	}
	@Mutation
	[Mutations.CLEAR_VALUES](payload) {
		this.values[payload.key] = {};
	}
	@Mutation
	[Mutations.SET_DYNAMIC_ENTITY_RELATIONSHIPS](payload) {
		if (!this.relationships[payload.key]) {
			this.relationships[payload.key] = {};
		}
		this.relationships[payload.key][payload.name] = payload.relationshipData;
	}
	@Mutation
	[Mutations.SET_SUCCESSFULLY_SUBMITTED](payload) {

		this.successFullySubmitted[payload.key] = payload.flag;
	}
	@Mutation
	[Mutations.PUSH_PRODUCT_ATTRIBUTE](payload) {
		this.values[payload.key].productAttributeValues.push(payload.productAttribute);
	}
	@Mutation
	[Mutations.REMOVE_PRODUCT_ATTRIBUTE](payload) {
		this.values[payload.key].productAttributeValues.splice(payload.index, 1);
	}
	@Mutation
	[Mutations.SET_FORM_WITH_IMAGE_FLAG](payload) {
		this.formWithImage[payload.key] = payload.flag;
	}
	@Mutation
	[Mutations.CLEAR_FORM_MODULE]() {
		this.dynamicEntity = {};
		this.relationships = {};
		this.mapping = {} as any;
		this.values = {} as any;
		this.id = {};
		this.formWithImage = {};
		this.successFullySubmitted = {};

	}

	/**
	 * Get dynamic list object
	 *
	 */
	get getDynamicEntity() {
		return (payload) => {
			return this.dynamicEntity[payload.key];
		}
	}
	get getFormLoading() {
		return this.formLoading;
	}

	/**
	 * Get mapping object
	 * @returns Mapping
	 */
	get getFormMapping() {
		return (payload) => {
			return this.mapping[payload.key];
		}
	}
	get getFormValues() {
		return (payload) => {
			return this.values[payload.key];
		}
	}
	get getEntityID() {
		return (payload) => {
			return this.id[payload.key];
		}
	}
	get getFormMappingColumns() {
		return (payload) => {

			if (this.mapping[payload.key]) {

				if (this.mapping[payload.key].map) {

					if (this.mapping[payload.key].map.Inputs) return this.mapping[payload.key].map.Inputs;
				}
			}
			return null;
		}
	}
	get getFormSideBar() {
		return (payload) => {

			if (this.mapping[payload.key]) {

				if (this.mapping[payload.key].map) {

					if (this.mapping[payload.key].map.SideBar) return this.mapping[payload.key].map.SideBar;
				}
			}
			return null;
		}
	}
	get getValidationSchema() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					if (this.id[payload.key] == 0) {
						if (this.mapping[payload.key].map.ValidationSchemaForAdd) return this.mapping[payload.key].map.ValidationSchemaForAdd;
						if (this.mapping[payload.key].map.ValidationSchema) return this.mapping[payload.key].map.ValidationSchema;
					}
					else {
						if (this.mapping[payload.key].map.ValidationSchema) return this.mapping[payload.key].map.ValidationSchema;
					}

				}
			}
			return null;
		}
	}
	get getMultipleFormEdit() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					return this.mapping[payload.key].map.MultipleFormEdit;
				}
			}
			return false;
		}
	}
	get getFormName() {
		return (payload) => {
			if (this.mapping[payload.key]) {
				if (this.mapping[payload.key].map) {
					if (this.mapping[payload.key].map.Single) {
						if (this.id[payload.key] != 0) {
							return 'Edit ' + this.mapping[payload.key].map.Single
						}
						else {
							return 'Add ' + this.mapping[payload.key].map.Single
						}
					}
				}
			}
			return false;
		}
	}
	get getRelationships() {
		return (payload) => {

			return this.relationships[payload.key];
		}
	}
	get getIsPage() {
		return (payload) => {
			
			return (this.mapping[payload.key].map.IsPage)?this.mapping[payload.key].map.IsPage:false;
		}
	}
	get getFormWithImage() {
		return (payload) => {
			return this.formWithImage[payload.key];
		}
	}
}
